<!-- List of currently active filters. -->

<template>
<div v-if="filterList.length > 0" class="active-filter-list">
    <span class="first">{{$t("active_filters")}}:</span>
    <span class="filter" v-for="(filter, index) in filterList" :key="index">
        {{ addUnits(filter.filterName, filter.value) }} <span class="cross" @click="setFilter(filter.value, filter.filterName)">&#215;</span>
    </span>
</div>
</template>



<script>
import { pick } from 'lodash';
import { addUnits, colorCri } from '@/services/utils';

export default {
    name: 'SearchFilterList',
    
    computed: {
        facets() {
            let facetsList = this.$store.state.search.facets;
            if (facetsList.hasOwnProperty('type')) {
                this.typeFilter = facetsList['type'];
                delete facetsList['type'];
            }

            this.$store.state.search.loading = '';
            return facetsList;
        },

        visibleFacets() {
            return pick(this.facets, this.$store.state.search.getFacetList());
        },

        filterValues() {
            let facets = this.visibleFacets;
            let tags = [];
            
            for (let f in facets) {
                for (let fv in facets[f]) {
                    let value = facets[f][fv];
                    if (value.selected) {
                        let v = {...facets[f][fv]};
                        v["filter"] = f;
                        tags.push(v);
                    }
                }
            }

            return tags;
        },

        filters() {
            return this.$store.state.search.filters;
        },

        // Lists all filter values except the ones within the "type" filter.
        filterList() {
            let filters = this.$store.state.search.filters;
            let l = [];

            for (let filter of filters) {
                let name = Object.keys(filter)[0];
                // Skip "type" filter
                if (name === "type")
                    continue;

                for (let value of filter[name])
                    l.push({
                        filterName: name,
                        value
                    });
            }
            return l;
        }
    },

    methods: {
        addUnits(facet, value) {
            let units = addUnits(this.$store.state.search.unitDictionary, facet, value);
            if (facet == "color") {
                units += " " + colorCri(value);
            }
            return units;
        },

        setFilter(item, filter) {
            this.$store.state.search.loading = filter;
            let exist = false;
            let checked = "unchecked";
            let filters = [...this.filters];

            // Check if filter already exists
            for (let filterObject of filters) {
                // Look for the right filter group
                if (filterObject[filter] == null)
                    continue;

                // The "type" filter is the only one that should be a radio instead of a checkbox.
                if(filter === "type") {
                    filterObject.type = [item];
                    exist = true;
                }
                else {
                    const index = filterObject[filter].indexOf(item);
                    if(index === -1) {
                        filterObject[filter].push(item);
                        exist = true;
                        checked = "checked";
                    } else {
                        filterObject[filter].splice(index, 1);
                        exist = true;
                    }
                }
            }

            // If filter doesn't exist, add new filter
            if (!exist) {
                const filterObject = {};
                filterObject[filter] = [item];
                filters.push(filterObject);
            }

            // Remove filters with no values
            filters = filters.filter(filterObject => {
                let key = Object.keys(filterObject)[0];
                return filterObject[key].length > 0;
            });

            this.$store.commit('search/filters', filters);

            //Radio button value is always checked
            if(filter === 'type'){
                checked = "checked";
            }
            //If filter is a radio button check if filter already exists
            else if(!exist){

                //filter doesn't exists, which means it's now checked
                checked = 'checked';
            }
            try {
                omniture.trackFilterWithActiveFilters(filter, item, checked, filters);
            } catch (e) {}
            this.$store.dispatch('search/search');
        },
    }
}
</script>



<style lang="scss" scoped>
.active-filter-list {
    >.first {
        @include media-breakpoint-down(md) {
            display: none;
        }
    }

    & > * {
        float: left;
        margin-right: 5px;
    }

    & > *:first-child {
        position: relative;
        top: 0.25em;
    }

    .filter {
        display: block;
        position: relative;
        
        padding: 5px 20px 5px 5px;
        margin-bottom: 5px;

        box-sizing: border-box;
        border: 1px solid #188CBF;
        border-radius: 2px;
        font-size: $nc-fsz-xs;
        color: $nc-blue-primary;

        .cross {
            position: absolute;
            top: 9%;
            margin-left: 0.15em;
            font-size: 20px;
            line-height: 20px;

            cursor: pointer;
        }
    }
    .filter::after {
        content: '';
    }

}

</style>
